// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { useLocation, useNavigate, Link } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { toast } from "react-hot-toast";
// import { 
//   Tag, Truck, ShieldCheck, X, Edit2, 
//   MessageSquare, Plus, Minus, Ticket 
// } from "lucide-react";
// import SummaryApi from "../common/SummaryApi";
// import api from "../common/apiClient";
// import { useCart } from "../context/CartContext";
// import { normalizeCartItem } from "../helpers/cartNormalizer";
// import AddressFormModal from "../components/CheckOutComponents/AddressFormModal";
// import Breadcrumb from "../components/BreadCrumb";

// const CheckOutPage = () => {
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const { refreshCart } = useCart(); // Assuming this is fetchUserAddToCart equivalent
//   const user = useSelector((state) => state?.user?.user);

//   const [items, setItems] = useState(state?.items || []);
//   const [loading, setLoading] = useState(false);

//   // Address States
//   const [addresses, setAddresses] = useState([]);
//   const [shippingAddress, setShippingAddress] = useState(null);
//   const [billingAddress, setBillingAddress] = useState(null);
//   const [isBillingDifferent, setIsBillingDifferent] = useState(false);

//   // Modals & UI States
//   const [showSelectionModal, setShowSelectionModal] = useState(false);
//   const [showFormModal, setShowFormModal] = useState(false);
//   const [showCouponModal, setShowCouponModal] = useState(false);
//   const [editingAddress, setEditingAddress] = useState(null);
//   const [targetType, setTargetType] = useState("shipping");

//   // Coupon & Instructions
//   const [promoCode, setPromoCode] = useState("");
//   const [couponDiscount, setCouponDiscount] = useState(0);
//   const [applicableCoupons, setApplicableCoupons] = useState([]);
//   const [specialInstructions, setSpecialInstructions] = useState("");

//   const breadcrumbItems = [
//     { label: "Home", path: "/" },
//     { label: "Products", path: "/all-userproducts" },
//     { label: "Cart", path: "/cart-page" },
//     { label: "Checkout" },
//   ];


//   // Memoize Product IDs to prevent re-fetching coupons when only quantity changes
//   const productIdsString = useMemo(() => items.map(i => i.productId).sort().join(','), [items]);

//   // Recalculate Summary locally (No API fetch)
//   const summary = useMemo(() => {
//     return items.reduce(
//       (acc, item) => {
//         const mrpTotal = item.mrp * item.quantity;
//         const priceTotal = item.price * item.quantity;
//         acc.subtotal += mrpTotal;
//         acc.discount += mrpTotal - priceTotal;
//         acc.payable += priceTotal;
//         return acc;
//       },
//       { subtotal: 0, discount: 0, payable: 0 }
//     );
//   }, [items]);

//   const deliveryCharge = summary.payable > 200 || summary.payable === 0 ? 0 : 70;
//   const totalAmount = Math.max(0, summary.payable + deliveryCharge - couponDiscount);

//   // Stock-based Quantity Update
//   const updateQty = (id, type) => {
//       const itemToUpdate = items.find(it => it._id === id);
//       if (!itemToUpdate) return;
  
//       if (type === 'inc') {
//         if (itemToUpdate.quantity >= itemToUpdate.stock) {
//           toast.error(`Only ${itemToUpdate.stock} items available in stock`, { id: `limit-${id}` });
//           return; 
//         }
//       }
  
//       setItems(prev => prev.map(item => {
//         if (item._id === id) {
//           return { ...item, quantity: type === 'inc' ? item.quantity + 1 : Math.max(1, item.quantity - 1) };
//         }
//         return item;
//       }));
//     };

//   const fetchAddresses = useCallback(async () => {
//     try {
//       const res = await api(SummaryApi.getMyAddresses);
//       const all = res.data.addresses || [];
//       setAddresses(all);
//       setShippingAddress(prev => prev ? (all.find(a => a._id === prev._id) || prev) : (all.find(a => a.isDefault) || all[0]));
//       setBillingAddress(prev => prev ? (all.find(a => a._id === prev._id) || prev) : (all.find(a => a.isDefault) || all[0]));
//     } catch (err) { console.error(err); }
//   }, []);

//   const fetchApplicableCoupons = useCallback(async () => {
//     if (items.length === 0) return;
//     try {
//       const pIds = items.map(i => i.productId);
//       const res = await api({ ...SummaryApi.getApplicableCoupons, data: { productIds: pIds } });
//       if (res.data.success) setApplicableCoupons(res.data.data);
//     } catch (err) { console.error("Coupon fetch failed", err); }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [productIdsString]);

//   // Initial Load & Address Fetch
//   useEffect(() => {
//     fetchAddresses();
//     if (!state?.items) {
//       const loadCart = async () => {
//         setLoading(true);
//         try {
//           const res = await api(SummaryApi.getCartItems);
//           setItems(res.data.items.map(normalizeCartItem));
//         } catch (e) { toast.error("Cart error"); }
//         finally { setLoading(false); }
//       };
//       loadCart();
//     }
//   }, [fetchAddresses, state?.items]);

//   // Coupon fetch independent of address/quantity
//   useEffect(() => {
//     fetchApplicableCoupons();
//   }, [fetchApplicableCoupons]);

//   const handleApplyPromo = async (code) => {
//     const codeToApply = code || promoCode;
//     if(!codeToApply) return toast.error("Enter Code");
//     try {
//         const res = await api({ ...SummaryApi.verifyCoupon, data: { couponCode: codeToApply, cartItems: items } });
//         if(res.data.success) {
//             setCouponDiscount(res.data.data.discountAmount);
//             setPromoCode(codeToApply);
//             setShowCouponModal(false);
//             toast.success("Coupon Applied!");
//         } else { toast.error(res.data.message); }
//     } catch (e) { toast.error("Invalid Code"); }
//   }

//   /**
//    * INTEGRATED HANDLESUBMIT LOGIC
//    */
//   const handlePlaceOrder = async (e) => {
//     if (e) e.preventDefault();

//     // 1. Validation
//     if (!shippingAddress) {
//       toast.error("Please select a shipping address before proceeding.");
//       return;
//     }

//     // 2. Prepare standardized payload
//     const orderItems = items.map(i => ({ 
//       productId: i.productId, 
//       variantId: i.variantId, 
//       sizeId: i.sizeId, 
//       quantity: i.quantity 
//     }));

//     const customerInfo = {
//       name: shippingAddress.name,
//       phone: shippingAddress.phone,
//       alternativePhone: user?.phone || null,
//       street: shippingAddress.flat + ", " + shippingAddress.area,
//       city: shippingAddress.city,
//       state: shippingAddress.state,
//       pincode: shippingAddress.pincode,
//       email: user?.email // Fallback email
//     };

//     const billingAddressToSend = isBillingDifferent ? billingAddress : shippingAddress;

//     setLoading(true);

//     // 4. RAZORPAY FLOW
//     try {
//       const payload = {
//         cartItems: orderItems,
//         customerInfo: {
//           ...customerInfo,
//           billingAddress: billingAddressToSend,
//         },
//         billingSameAsShipping: !isBillingDifferent,
//         shippingOption: deliveryCharge === 0 ? "Free" : "Paid",
//         couponCode: promoCode || null,
//         couponDiscount: couponDiscount,
//         instructions: specialInstructions
//       };

//       // Create Order in Backend
//       const paymentResponse = await api({ ...SummaryApi.createOrder, data: payload });

//       if (paymentResponse.data.success) {
//         const options = {
//           key: "rzp_test_RyBnpI4IJfC1QM", // Keep your keys here
//           amount: totalAmount * 100, // In Paise
//           currency: "INR",
//           name: "Regees Textiles",
//           description: "e-commerce order",
//           image: "/client/src/assets/images/logo.png",
//           order_id: paymentResponse.data.razorpayOrder.id,
//           handler: async function (response) {
//             // Keep the loading screen active during verification
//             setLoading(true); 
//             try {
//               const paymentVerification = await api({
//                 ...SummaryApi.verifyPayment,
//                 data: {
//                   razorpayPaymentId: response.razorpay_payment_id,
//                   razorpayOrderId: response.razorpay_order_id,
//                   razorpaySignature: response.razorpay_signature,
//                   cartItems: orderItems,
//                   customerInfo,
//                   couponCode: promoCode || null,
//                   couponDiscount: couponDiscount
//                 }
//               });

//               if (paymentVerification.data.success) {
//                 toast.success("Payment successful!");
//                 refreshCart();
//                 navigate("/success");
//               } else {
//                 toast.error("Payment verification failed. Please contact support.");
//                 navigate("/cancel");
//               }
//             } catch (err) {
//               toast.error("Verification Error");
//               navigate("/cancel");
//             } finally {
//               setLoading(false);
//             }
//           },
//           modal: {
//             ondismiss: function() {
//               setLoading(false); // Stop loading if user closes modal
//             }
//           },
//           prefill: {
//             name: customerInfo.name,
//             email: user?.email,
//             contact: customerInfo.phone,
//           },
//           notes: {
//             address: customerInfo.street,
//           },
//           theme: { color: "#007BFF" }
//         };

//         const rzp1 = new window.Razorpay(options);
//         rzp1.open();
//       } else {
//         setLoading(false);
//         toast.error(paymentResponse.data.message || "Failed to create Razorpay order");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       toast.error("Error with payment processing. Please try again later.");
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="bg-[#F8FAFF] py-6 font-sans text-[#1A1A1A]">
//       <div className="px-4 md:px-6">
        
//         {/* HEADER */}
//         <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
//           <div className="flex items-center gap-4">
//              <h1 className="text-xl md:text-2xl font-bold tracking-tight">Checkout</h1>
//           </div>
//           <Link to="/cart-page" className="text-sm font-bold text-blue-600 hover:underline flex items-center gap-1 px-2">Edit Cart Items</Link>
//         </div>
//         {/* BREADCRUMB */}
//         <div className="mb-4">
//           <Breadcrumb items={breadcrumbItems} />
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          
//           {/* LEFT SECTION */}
//           <div className="lg:col-span-7 space-y-6">
            
//             <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 flex justify-between items-center shadow-sm">
//               <span className="text-sm md:text-base font-medium tracking-widest text-gray-600">{user?.phone || user?.email || "Guest"}</span>
//             </div>

//             <div className="space-y-4">
//               <h3 className="text-base md:text-lg font-bold">Delivery address</h3>
//               <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm relative flex justify-between items-center">
//                 {shippingAddress ? (
//                   <div className="text-sm md:text-base leading-snug text-gray-700 space-y-1">
//                     <p className="font-bold text-black">{shippingAddress.name}</p>
//                     <p>{shippingAddress.flat}, {shippingAddress.area}</p>
//                     <p className="uppercase">{shippingAddress.city}, {shippingAddress.state} {shippingAddress.pincode}</p>
//                     <p className="mt-1 font-bold text-gray-800 tracking-wide">{shippingAddress.phone}</p>
//                   </div>
//                 ) : <p className="text-gray-400">Loading address...</p>}
//                 <button onClick={() => { setTargetType("shipping"); setShowSelectionModal(true); }} className="text-blue-500 font-bold text-sm hover:underline ml-4">Change</button>
//               </div>
//             </div>

//             <label className="flex items-center gap-3 px-2 cursor-pointer">
//               <input type="checkbox" checked={isBillingDifferent} onChange={() => setIsBillingDifferent(!isBillingDifferent)} className="w-5 h-5 rounded border-gray-300 text-blue-500 focus:ring-blue-400" />
//               <span className="text-gray-500 text-sm md:text-base font-medium">Billing address is different</span>
//             </label>

//             {isBillingDifferent && (
//                <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm relative flex justify-between items-center animate-in slide-in-from-top-2">
//                   {billingAddress ? (
//                     <div className="text-sm md:text-base leading-snug text-gray-700 space-y-1">
//                       <p className="font-bold text-black">{billingAddress.name}</p>
//                       <p>{billingAddress.flat}, {billingAddress.area}</p>
//                       <p className="uppercase">{billingAddress.city}, {billingAddress.pincode}</p>
//                     </div>
//                   ) : <p className="text-gray-400">Select billing address</p>}
//                   <button onClick={() => { setTargetType("billing"); setShowSelectionModal(true); }} className="text-blue-500 font-bold text-sm hover:underline ml-4">Change</button>
//                </div>
//             )}

//             {/* ITEM CARDS */}
//             <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm divide-y divide-gray-100">
//               {items.map((item, idx) => (
//                 <div key={idx} className="py-4 first:pt-0 last:pb-0">
//                   {/* MOBILE VIEW */}
//                   <div className="flex sm:hidden flex-col">
//                     <div className="flex gap-4">
//                       <div className="w-[85px] h-[85px] bg-gray-50 rounded-lg overflow-hidden border shrink-0">
//                         <img src={item.image} className="w-full h-full object-cover" alt="" />
//                       </div>
//                       <div className="flex-1">
//                         <h4 className="text-[13px] font-bold text-gray-800 leading-tight line-clamp-2 mb-1">{item.productName}</h4>
//                         {item.stock <= 5 && <p className="text-[10px] font-black uppercase text-orange-500">🔥 Only {item.stock} left</p>}

//                         <div className="flex items-center gap-3 mt-2 border-2 border-[#D9F2F9] bg-[#F6FAFD] w-fit px-2 py-1 rounded-md">
//                           <button onClick={() => updateQty(item._id, 'dec')} className="text-gray-500 p-0.5"><Minus size={14}/></button>
//                           <span className="text-xs font-bold w-4 text-center">{item.quantity}</span>
//                           <button onClick={() => updateQty(item._id, 'inc')} className="text-blue-600 p-0.5"><Plus size={14}/></button>
//                         </div>

//                       </div>
//                     </div>
//                     <div className="flex justify-between items-end">
//                       <div>
//                         <p className="text-xs text-gray-500">Size: <span className="text-black font-semibold">{item.size}</span></p>
//                         {item.color && (
//                           <div className="flex items-center gap-2 mt-1 text-xs text-gray-500">
//                             <span>Color:</span>
//                             <div className="w-5 h-2.5 rounded-sm border" style={{ backgroundColor: item.colorCode || item.color }} />
//                           </div>
//                         )}
//                       </div>
//                       <div className="text-right flex flex-col items-end">
//                          <p className="text-lg font-black text-black">₹{(item.price * item.quantity).toFixed(0)}</p>
//                          <p className="text-xs text-gray-400 line-through">₹{(item.mrp * item.quantity).toFixed(0)}</p>
//                          <div className="bg-yellow-300 text-[11px] font-black px-2.5 py-1 rounded mt-2.5 uppercase tracking-wider">
//                              {item.discountPercent}% OFF
//                            </div>
//                       </div>
//                     </div>
//                   </div>

//                   {/* DESKTOP VIEW */}
//                   <div className="hidden sm:flex flex-row gap-6 items-stretch">
//                     <div className="w-24 h-32 bg-gray-50 rounded-xl overflow-hidden border shrink-0">
//                       <img src={item.image} className="w-full h-full object-cover" alt="" />
//                     </div>
//                     <div className="flex-1 flex flex-col justify-between">
//                       <div>
//                         <h4 className="text-base font-bold text-gray-800 leading-snug line-clamp-2">{item.productName}</h4>
//                         {item.stock <= 5 && <p className="text-[11px] font-bold uppercase mt-1 text-orange-500">🔥 Only {item.stock} left</p>}
//                       </div>
//                       <div className="flex justify-between items-end">
//                         <div className="flex items-center gap-8">
//                           <div className="text-sm text-gray-500">
//                              Size: <span className="text-black font-bold">{item.size}</span>
//                              {item.color && (
//                                <div className="flex items-center gap-2 mt-1">
//                                  <span>Color:</span>
//                                  <div className="w-5 h-2.5 rounded-sm border" style={{ backgroundColor: item.colorCode || item.color }} />
//                                </div>
//                              )}
//                           </div>
//                           <div className="w-[90px] flex items-center gap-3 border-2 border-[#D9F2F9] bg-[#F6FAFD] px-2 py-1.5 rounded-lg">
//                             <button onClick={() => updateQty(item._id, 'dec')} className="text-gray-400 hover:text-red-500 transition-colors"><Minus size={16}/></button>
//                             <span className="text-sm font-black w-5 text-center">{item.quantity}</span>
//                             <button onClick={() => updateQty(item._id, 'inc')} className="text-blue-500 hover:text-blue-700 transition-colors"><Plus size={16}/></button>
//                           </div>
//                         </div>
//                         <div className="text-right">
//                           <p className="text-xl font-black text-black leading-none">₹{(item.price * item.quantity).toFixed(2)}</p>
//                           <p className="text-xs text-gray-400 line-through mt-1.5 font-medium">₹{(item.mrp * item.quantity).toFixed(2)}</p>
//                           <div className="bg-yellow-300 text-[11px] font-black px-2.5 py-1 rounded mt-2.5 uppercase tracking-wider">
//                              {item.discountPercent}% OFF
//                            </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {/* SPECIAL INSTRUCTIONS */}
//             <div className="bg-white rounded-2xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm">
//                 <div className="flex items-center gap-3 mb-5">
//                    <MessageSquare className="text-gray-800" size={20} strokeWidth={2.5}/>
//                    <h3 className="font-bold text-base md:text-lg">Special Instructions</h3>
//                 </div>
//                 <div className="space-y-4">
//                   <p className="text-gray-500 font-medium text-sm">Add a note to your order (optional)</p>
//                   <textarea 
//                     value={specialInstructions}
//                     onChange={(e) => setSpecialInstructions(e.target.value)}
//                     placeholder="Any special requests, notes..."
//                     className="w-full h-20 bg-[#F3F5F7] rounded-xl p-4 text-sm outline-none resize-none focus:ring-1 ring-blue-200"
//                   />
//                 </div>
//             </div>
//           </div>

//           {/* RIGHT SECTION: SUMMARY */}
//           <div className="lg:col-span-5 space-y-6">
//             <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm">
//               <div className="flex justify-between items-center mb-4">
//                 <h3 className="text-sm md:text-base font-bold flex items-center gap-2"><Tag size={18} /> Promo Code</h3>
//                 {applicableCoupons.length > 0 && <button onClick={() => setShowCouponModal(true)} className="text-xs font-bold text-blue-600 flex items-center gap-1.5 hover:underline"><Ticket size={14}/> View all({applicableCoupons.length})</button>}
//               </div>
//               <div className="flex gap-2 mb-3">
//                 <input type="text" value={promoCode} onChange={(e) => setPromoCode(e.target.value.toUpperCase())} placeholder="Enter code" className="flex-1 bg-blue-50/50 rounded-lg px-4 py-3 text-sm outline-none focus:ring-1 ring-blue-300" />
//                 <button onClick={() => handleApplyPromo()} className="px-5 py-2 border border-[#B5CAFF] text-blue-500 rounded-lg text-sm font-bold hover:bg-blue-50 transition-colors">Apply</button>
//               </div>
              
//             </div>

//             <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm">
//               <h3 className="text-base md:text-lg font-bold mb-6">Order Summary</h3>
//               <div className="space-y-4 text-sm md:text-base font-medium text-gray-500">
//                 <div className="flex justify-between">
//                   <span>Subtotal ({items.reduce((a, b) => a + b.quantity, 0)} items)</span>
//                   <span className="text-black font-bold">₹{summary.subtotal.toFixed(2)}</span>
//                 </div>
//                 <div className="flex justify-between text-green-600">
//                   <span>Discount</span>
//                   <span>-₹{summary.discount.toFixed(2)}</span>
//                 </div>
//                 {couponDiscount > 0 && (
//                    <div className="flex justify-between text-blue-600">
//                     <span>Coupon Discount</span>
//                     <span>-₹{couponDiscount.toFixed(2)}</span>
//                   </div>
//                 )}
//                 {summary.payable > 0 && (
//                     <div className="flex justify-between items-start">
//                       <span>Delivery</span>

//                       {deliveryCharge === 0 ? (
//                         <div className="text-right leading-tight">
//                           <span className="mr-2 line-through text-gray-400">
//                             ₹120.00
//                           </span>
//                           <span className="text-[#008622] font-medium">
//                             Free
//                           </span>
//                         </div>
//                       ) : (
//                         <div className="text-right leading-tight">
//                           <span className="mr-2 line-through text-gray-400">
//                             ₹120.00
//                           </span>
//                           <span>₹{deliveryCharge.toFixed(2)}</span>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 <div className="pt-6 border-t flex justify-between items-center text-black">
//                   <span className="text-lg font-bold">Total</span>
//                   <span className="text-2xl font-black">₹{totalAmount.toFixed(2)}</span>
//                 </div>
//               </div>
//               <button 
//                 onClick={handlePlaceOrder} 
//                 disabled={loading || items.length === 0} 
//                 className="w-full bg-[#007BFF] hover:bg-blue-700 text-white py-4 rounded-xl mt-8 font-bold shadow-lg active:scale-[0.98] transition-all disabled:bg-gray-400 tracking-wider"
//               >
//                 {loading ? "PROCESSING..." : "PLACE ORDER"}
//               </button>
//               {/* SAVINGS INFO */}
//               {summary.discount > 0 && (
//                 <p className="mt-4 py-3 rounded-lg text-sm bg-green-100 text-[#008622] text-center">
//                   You will save ₹{summary.discount.toFixed(2)} on this order
//                 </p>
//               )}
//             </div>

//             <div className="bg-white rounded-xl border border-[#B5CAFF] p-6 space-y-6 text-gray-500">
//                <div className="flex items-center gap-4"><Truck className="text-blue-500" size={20}/><div><p className="text-sm font-bold text-black">Safe Delivery</p><p className="text-xs">Tracking available after dispatch</p></div></div>
//                <div className="flex items-center gap-4 border-t pt-5 border-gray-50"><ShieldCheck className="text-green-500" size={20}/><div><p className="text-sm font-bold text-black">Buyer Protection</p><p className="text-xs">Secure payment & easy returns</p></div></div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* MODALS */}
//       {showSelectionModal && (
//         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[2000] flex items-center justify-center p-4">
//           <div className="bg-white w-full max-w-lg rounded-3xl overflow-hidden shadow-2xl animate-in zoom-in duration-200">
//              <div className="p-6 bg-blue-600 text-white flex justify-between items-center"><h2 className="font-bold text-lg">Select Address</h2><button onClick={() => setShowSelectionModal(false)}><X size={24}/></button></div>
//              <div className="p-6 max-h-[60vh] overflow-y-auto space-y-4 bg-gray-50">
//                 {addresses.map((addr) => (
//                   <div key={addr._id} className="relative bg-white p-5 rounded-2xl border-2 border-transparent hover:border-blue-500 cursor-pointer shadow-sm transition-all group">
//                     <div onClick={() => { if(targetType === "shipping") setShippingAddress(addr); else setBillingAddress(addr); setShowSelectionModal(false); }}>
//                       <p className="font-bold text-gray-900">{addr.name}</p>
//                       <p className="text-sm text-gray-500 mt-1">{addr.flat}, {addr.area}</p>
//                     </div>
//                     <button onClick={(e) => { e.stopPropagation(); setEditingAddress(addr); setShowSelectionModal(false); setShowFormModal(true); }} className="absolute top-4 right-4 p-2 text-gray-300 hover:text-blue-500 bg-gray-50 rounded-lg"><Edit2 size={16} /></button>
//                   </div>
//                 ))}
//                 <button onClick={() => { setShowSelectionModal(false); setEditingAddress(null); setShowFormModal(true); }} className="w-full py-4 rounded-2xl border-2 border-dashed border-blue-200 text-blue-500 font-bold hover:bg-blue-50">+ Add New Address</button>
//              </div>
//           </div>
//         </div>
//       )}

//       {showCouponModal && (
//         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[2000] flex items-center justify-center p-4">
//           <div className="bg-white w-full max-w-md rounded-3xl overflow-hidden shadow-2xl animate-in zoom-in duration-200">
//              <div className="p-5 border-b flex justify-between items-center"><h2 className="font-bold text-lg">Available Coupons</h2><button onClick={() => setShowCouponModal(false)} className="p-1 rounded-full hover:bg-gray-100"><X size={24}/></button></div>
//              <div className="p-5 max-h-[60vh] overflow-y-auto space-y-4">
//                {applicableCoupons.length > 0 ? applicableCoupons.map((c) => (
//                  <div key={c._id} className="border-2 border-dashed border-blue-200 rounded-2xl p-4 flex justify-between items-center bg-blue-50/30">
//                    <div>
//                      <p className="text-blue-600 font-black text-lg tracking-tight">{c.code}</p>
//                      <p className="text-xs font-bold text-gray-600 mt-0.5">{c.discountType === 'percentage' ? `${c.discountValue}% OFF` : `₹${c.discountValue} OFF`}</p>
//                    </div>
//                    <button onClick={() => handleApplyPromo(c.code)} className="bg-blue-600 text-white text-xs font-bold px-4 py-2 rounded-lg hover:bg-blue-700">APPLY</button>
//                  </div>
//                )) : <div className="text-center py-10"><Tag size={40} className="mx-auto text-gray-200 mb-3"/><p className="text-sm font-medium text-gray-400">No coupons available for these items.</p></div>}
//              </div>
//           </div>
//         </div>
//       )}
//       <AddressFormModal isOpen={showFormModal} onClose={() => { setShowFormModal(false); setEditingAddress(null); }} onSuccess={fetchAddresses} initialData={editingAddress} />
//     </div>
//   );
// };

// export default CheckOutPage;

import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { 
  Tag, Truck, ShieldCheck, X, Edit2, 
  MessageSquare, Plus, Minus, Ticket 
} from "lucide-react";
import SummaryApi from "../common/SummaryApi";
import api from "../common/apiClient";
import { useCart } from "../context/CartContext";
import { normalizeCartItem } from "../helpers/cartNormalizer";
import AddressFormModal from "../components/CheckOutComponents/AddressFormModal";
import Breadcrumb from "../components/BreadCrumb";
// NEW COMPONENT IMPORT
import AuthModal from "../components/CheckOutComponents/AuthModal";

const CheckOutPage = () => {
  const { state } = useLocation();
  const cameFromCart = state?.from === "cart";
  const navigate = useNavigate();
  const { refreshCart } = useCart(); // Assuming this is fetchUserAddToCart equivalent
  const user = useSelector((state) => state?.user?.user);
  const token = localStorage.getItem("token");
  const [items, setItems] = useState(state?.items || []);
  const [loading, setLoading] = useState(false);

  // AUTH MODAL STATE
  const [showAuthModal, setShowAuthModal] = useState(false);

  // Address States
  const [addresses, setAddresses] = useState([]);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [billingAddress, setBillingAddress] = useState(null);
  const [isBillingDifferent, setIsBillingDifferent] = useState(false);

  // Modals & UI States
  const [showSelectionModal, setShowSelectionModal] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [targetType, setTargetType] = useState("shipping");

  // Coupon & Instructions
  const [promoCode, setPromoCode] = useState("");
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [applicableCoupons, setApplicableCoupons] = useState([]);
  const [specialInstructions, setSpecialInstructions] = useState("");

const breadcrumbItems = [
  { label: "Home", path: "/" },
  { label: "Products", path: "/all-userproducts" },
  ...(cameFromCart
    ? [{ label: "Cart", path: "/cart-page" }]
    : []),
  { label: "Checkout" },
];



  // Memoize Product IDs to prevent re-fetching coupons when only quantity changes
  const productIdsString = useMemo(() => items.map(i => i.productId).sort().join(','), [items]);

  // Recalculate Summary locally (No API fetch)
  const summary = useMemo(() => {
    return items.reduce(
      (acc, item) => {
        const mrpTotal = item.mrp * item.quantity;
        const priceTotal = item.price * item.quantity;
        acc.subtotal += mrpTotal;
        acc.discount += mrpTotal - priceTotal;
        acc.payable += priceTotal;
        return acc;
      },
      { subtotal: 0, discount: 0, payable: 0 }
    );
  }, [items]);

  const DELIVERY_FREE_LIMIT = 1000;

  const isFreeDelivery =
    summary.payable >= DELIVERY_FREE_LIMIT || summary.payable === 0;

  const deliveryCharge = isFreeDelivery ;

  const totalAmount = Math.max(0, summary.payable  - couponDiscount);

  // Stock-based Quantity Update
  const updateQty = (id, type) => {
      const itemToUpdate = items.find(it => it._id === id);
      if (!itemToUpdate) return;
  
      if (type === 'inc') {
        if (itemToUpdate.quantity >= itemToUpdate.stock) {
          toast.error(`Only ${itemToUpdate.stock} items available in stock`, { id: `limit-${id}` });
          return; 
        }
      }
  
      setItems(prev => prev.map(item => {
        if (item._id === id) {
          return { ...item, quantity: type === 'inc' ? item.quantity + 1 : Math.max(1, item.quantity - 1) };
        }
        return item;
      }));
    };

  const fetchAddresses = useCallback(async () => {
    // Stop address fetching if no token
    if(!token) return;
    
    try {
      const res = await api(SummaryApi.getMyAddresses);
      const all = res.data.addresses || [];
      setAddresses(all);
      setShippingAddress(prev => prev ? (all.find(a => a._id === prev._id) || prev) : (all.find(a => a.isDefault) || all[0]));
      setBillingAddress(prev => prev ? (all.find(a => a._id === prev._id) || prev) : (all.find(a => a.isDefault) || all[0]));
    } catch (err) { console.error(err); }
  }, [token]);

  const fetchApplicableCoupons = useCallback(async () => {
    if (items.length === 0) return;
    try {
      const pIds = items.map(i => i.productId);
      const res = await api({ ...SummaryApi.getApplicableCoupons, data: { productIds: pIds } });
      if (res.data.success) setApplicableCoupons(res.data.data);
    } catch (err) { console.error("Coupon fetch failed", err); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productIdsString]);

  // Initial Load & Address Fetch
  useEffect(() => {
    // CHECK FOR TOKEN ON LOAD
    if (!token) {
      setShowAuthModal(true);
    } else {
      fetchAddresses();
    }

    if (!state?.items) {
      const loadCart = async () => {
        setLoading(true);
        try {
          const res = await api(SummaryApi.getCartItems);
          setItems(res.data.items.map(normalizeCartItem));
        } catch (e) { toast.error("Cart error"); }
        finally { setLoading(false); }
      };
      loadCart();
    }
  }, [fetchAddresses, state?.items, token]);

  // Coupon fetch independent of address/quantity
  useEffect(() => {
    fetchApplicableCoupons();
  }, [fetchApplicableCoupons]);

  const handleApplyPromo = async (code) => {
    const codeToApply = code || promoCode;
    if(!codeToApply) return toast.error("Enter Code");
    try {
        const res = await api({ ...SummaryApi.verifyCoupon, data: { couponCode: codeToApply, cartItems: items } });
        if(res.data.success) {
            setCouponDiscount(res.data.data.discountAmount);
            setPromoCode(codeToApply);
            setShowCouponModal(false);
            toast.success("Coupon Applied!");
        } else { toast.error(res.data.message); }
    } catch (e) { toast.error("Invalid Code"); }
  }

  /**
   * INTEGRATED HANDLESUBMIT LOGIC
   */
  const handlePlaceOrder = async (e) => {
    if (e) e.preventDefault();

    // Re-check token before order
    if (!token) {
        setShowAuthModal(true);
        return;
    }

    // 1. Validation
    if (!shippingAddress) {
      toast.error("Please select a shipping address before proceeding.");
      return;
    }

    // 2. Prepare standardized payload
    const orderItems = items.map(i => ({ 
      productId: i.productId, 
      variantId: i.variantId, 
      sizeId: i.sizeId, 
      quantity: i.quantity 
    }));

    const customerInfo = {
      name: shippingAddress.name,
      phone: shippingAddress.phone,
      alternativePhone: user?.phone || null,
      street: shippingAddress.flat + ", " + shippingAddress.area,
      city: shippingAddress.city,
      state: shippingAddress.state,
      pincode: shippingAddress.pincode,
      email: user?.email // Fallback email
    };

    const billingAddressToSend = isBillingDifferent ? billingAddress : shippingAddress;

    setLoading(true);

    // 4. RAZORPAY FLOW
    try {
      const payload = {
        cartItems: orderItems,
        customerInfo: {
          ...customerInfo,
          billingAddress: billingAddressToSend,
        },
        billingSameAsShipping: !isBillingDifferent,
        shippingOption: deliveryCharge ? "Free" : "Paid",
        couponCode: promoCode || null,
        couponDiscount: couponDiscount,
        instructions: specialInstructions
      };

      // Create Order in Backend
      const paymentResponse = await api({ ...SummaryApi.createOrder, Authorization: `Bearer ${user?.token}`, data: payload });

      if (paymentResponse.data.success) {
        const options = {
          key: "rzp_live_S2q5i3jBViZq8p", // Keep your keys here
          // key: "rzp_test_RyBnpI4IJfC1QM", // Keep your keys here
          amount: totalAmount * 100, // In Paise
          currency: "INR",
          name: "Regees Textiles",
          description: "e-commerce order",
          image: "/client/src/assets/images/logo.png",
          order_id: paymentResponse.data.razorpayOrder.id,
          handler: async function (response) {
            // Keep the loading screen active during verification
            setLoading(true); 
            try {
              const paymentVerification = await api({
                ...SummaryApi.verifyPayment,
                Authorization: `Bearer ${user?.token}`,
                data: {
                  razorpayPaymentId: response.razorpay_payment_id,
                  razorpayOrderId: response.razorpay_order_id,
                  razorpaySignature: response.razorpay_signature,
                  cartItems: orderItems,
                  customerInfo,
                  couponCode: promoCode || null,
                  couponDiscount: couponDiscount
                }
              });

              if (paymentVerification.data.success) {
                toast.success("Payment successful!");
                refreshCart();
                navigate("/success");
              } else {
                toast.error("Payment verification failed. Please contact support.");
                navigate("/cancel");
              }
            } catch (err) {
              toast.error("Verification Error");
              navigate("/cancel");
            } finally {
              setLoading(false);
            }
          },
          modal: {
            ondismiss: function() {
              setLoading(false); // Stop loading if user closes modal
            }
          },
          prefill: {
            name: customerInfo.name,
            email: user?.email,
            contact: customerInfo.phone,
          },
          notes: {
            address: customerInfo.street,
          },
          theme: { color: "#007BFF" }
        };

        const rzp1 = new window.Razorpay(options);
        rzp1.open();
      } else {
        setLoading(false);
        toast.error(paymentResponse.data.message || "Failed to create Razorpay order");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error with payment processing. Please try again later.");
      setLoading(false);
    }
  };
//   const handlePlaceOrder = async (e) => {
//   if (e) e.preventDefault();

//   // 🚧 TEMPORARY BLOCK (UNDER DEVELOPMENT)
//   toast("Site is under development. Ordering will be enabled soon.", {
//     icon: "⚠️",
//     duration: 10000,
//   });
//   return;

//   // ❌ BELOW CODE WILL NOT RUN NOW
// };
  return (
    <div className="bg-[#F8FAFF] py-6 font-sans text-[#1A1A1A]">
      <div className="px-4 md:px-6">
        
        {/* HEADER */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
          <div className="flex items-center gap-4">
             <h1 className="text-xl md:text-2xl font-bold tracking-tight">Checkout</h1>
          </div>
         {cameFromCart && ( <Link to="/cart-page" className="text-sm font-bold text-blue-600 hover:underline flex items-center gap-1 px-2">Edit Cart Items</Link>)}
        </div>
        {/* BREADCRUMB */}
        <div className="mb-4">
          <Breadcrumb items={breadcrumbItems} />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          
          {/* LEFT SECTION */}
          <div className="lg:col-span-7 space-y-6">
            
            <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 flex justify-between items-center shadow-sm">
              <span className="text-sm md:text-base font-medium tracking-widest text-gray-600">{user?.phone || user?.email || "Guest"}</span>
            </div>

            <div className="space-y-4">
              <h3 className="text-base md:text-lg font-bold">Delivery address</h3>
              <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm relative flex justify-between items-center">
                {shippingAddress ? (
                  <div className="text-sm md:text-base leading-snug text-gray-700 space-y-1">
                    <p className="font-bold text-black">{shippingAddress.name}</p>
                    <p>{shippingAddress.flat}, {shippingAddress.area}</p>
                    <p className="uppercase">{shippingAddress.city}, {shippingAddress.state} {shippingAddress.pincode}</p>
                    <p className="mt-1 font-bold text-gray-800 tracking-wide">{shippingAddress.phone}</p>
                  </div>
                ) : <p className="text-gray-400">Select delivery address</p>}
                <button 
                  onClick={() => { 
                    if (!token) {
                      setShowAuthModal(true);
                      return;
                    }
                    setTargetType("shipping"); 
                    setShowSelectionModal(true); 
                  }} 
                  className="text-blue-500 font-bold text-sm hover:underline ml-4"
                >
                  Change
                </button>
              </div>
            </div>

            <label className="flex items-center gap-3 px-2 cursor-pointer">
              <input type="checkbox" checked={isBillingDifferent} onChange={() => setIsBillingDifferent(!isBillingDifferent)} className="w-5 h-5 rounded border-gray-300 text-blue-500 focus:ring-blue-400" />
              <span className="text-gray-500 text-sm md:text-base font-medium">Billing address is different</span>
            </label>

            {isBillingDifferent && (
               <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm relative flex justify-between items-center animate-in slide-in-from-top-2">
                  {billingAddress ? (
                    <div className="text-sm md:text-base leading-snug text-gray-700 space-y-1">
                      <p className="font-bold text-black">{billingAddress.name}</p>
                      <p>{billingAddress.flat}, {billingAddress.area}</p>
                      <p className="uppercase">{billingAddress.city}, {billingAddress.pincode}</p>
                    </div>
                  ) : <p className="text-gray-400">Select billing address</p>}
                  <button 
                    onClick={() => { 
                      if (!token) {
                        setShowAuthModal(true);
                        return; // This stops the code here if there's no token
                      }
                      // This part only runs if token exists
                      setTargetType("billing"); 
                      setShowSelectionModal(true); 
                    }} 
                    className="text-blue-500 font-bold text-sm hover:underline ml-4"
                  >
                    Change
                  </button>
               </div>
            )}

            {/* ITEM CARDS */}
            <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm divide-y divide-gray-100">
              {items.map((item, idx) => (
                <div key={idx} className="py-4 first:pt-0 last:pb-0">
                  {/* MOBILE VIEW */}
                  <div className="flex sm:hidden flex-col">
                    <div className="flex gap-4">
                      <div className="w-[85px] h-[85px] bg-gray-50 rounded-lg overflow-hidden border shrink-0">
                        <img src={item.image} className="w-full h-full object-cover" alt="" />
                      </div>
                      <div className="flex-1">
                        <h4 className="text-[13px] font-bold text-gray-800 leading-tight line-clamp-2 mb-1">{item.productName}</h4>
                        {item.stock <= 5 && <p className="text-[10px] font-black uppercase text-orange-500">🔥 Only {item.stock} left</p>}

                       {!cameFromCart && ( <div className="flex items-center gap-3 mt-2 border-2 border-[#D9F2F9] bg-[#F6FAFD] w-fit px-2 py-1 rounded-md">
                          <button onClick={() => updateQty(item._id, 'dec')} className="text-gray-500 p-0.5"><Minus size={14}/></button>
                          <span className="text-xs font-bold w-4 text-center">{item.quantity}</span>
                          <button onClick={() => updateQty(item._id, 'inc')} className="text-blue-600 p-0.5"><Plus size={14}/></button>
                        </div>
                        )}
                      </div>
                    </div>
                    <div className="flex justify-between items-end">
                      <div>
                        <p className="text-xs text-gray-500">Size: <span className="text-black font-semibold">{item.size}</span></p>
                        {item.color && (
                          <div className="flex items-center gap-2 mt-1 text-xs text-gray-500">
                            <span>Color:</span>
                            <div className="w-5 h-2.5 rounded-sm border" style={{ backgroundColor: item.colorCode || item.color }} />
                          </div>
                        )}
                      </div>
                      <div className="text-right flex flex-col items-end">
                         <p className="text-lg font-black text-black">₹{(item.price * item.quantity).toFixed(0)}</p>
                         <p className="text-xs text-gray-400 line-through">₹{(item.mrp * item.quantity).toFixed(0)}</p>
                         <div className="bg-yellow-300 text-[11px] font-black px-2.5 py-1 rounded mt-2.5 uppercase tracking-wider">
                             {item.discountPercent}% OFF
                           </div>
                      </div>
                    </div>
                  </div>

                  {/* DESKTOP VIEW */}
                  <div className="hidden sm:flex flex-row gap-6 items-stretch">
                    <div className="w-24 h-32 bg-gray-50 rounded-xl overflow-hidden border shrink-0">
                      <img src={item.image} className="w-full h-full object-cover" alt="" />
                    </div>
                    <div className="flex-1 flex flex-col justify-between">
                      <div>
                        <h4 className="text-base font-bold text-gray-800 leading-snug line-clamp-2">{item.productName}</h4>
                        {item.stock <= 5 && <p className="text-[11px] font-bold uppercase mt-1 text-orange-500">🔥 Only {item.stock} left</p>}
                      </div>
                      <div className="flex justify-between items-end">
                        <div className="flex items-center gap-8">
                          <div className="text-sm text-gray-500">
                             Size: <span className="text-black font-bold">{item.size}</span>
                             {item.color && (
                               <div className="flex items-center gap-2 mt-1">
                                 <span>Color:</span>
                                 <div className="w-5 h-2.5 rounded-sm border" style={{ backgroundColor: item.colorCode || item.color }} />
                               </div>
                             )}
                          </div>
                         {!cameFromCart && ( <div className="w-[90px] flex items-center gap-3 border-2 border-[#D9F2F9] bg-[#F6FAFD] px-2 py-1.5 rounded-lg">
                            <button onClick={() => updateQty(item._id, 'dec')} className="text-gray-400 hover:text-red-500 transition-colors"><Minus size={16}/></button>
                            <span className="text-sm font-black w-5 text-center">{item.quantity}</span>
                            <button onClick={() => updateQty(item._id, 'inc')} className="text-blue-500 hover:text-blue-700 transition-colors"><Plus size={16}/></button>
                          </div>
                          )}
                        </div>
                        <div className="text-right">
                          <p className="text-xl font-black text-black leading-none">₹{(item.price * item.quantity).toFixed(2)}</p>
                          <p className="text-xs text-gray-400 line-through mt-1.5 font-medium">₹{(item.mrp * item.quantity).toFixed(2)}</p>
                          <div className="bg-yellow-300 text-[11px] font-black px-2.5 py-1 rounded mt-2.5 uppercase tracking-wider">
                             {item.discountPercent}% OFF
                           </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* SPECIAL INSTRUCTIONS */}
            <div className="bg-white rounded-2xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm">
                <div className="flex items-center gap-3 mb-5">
                   <MessageSquare className="text-gray-800" size={20} strokeWidth={2.5}/>
                   <h3 className="font-bold text-base md:text-lg">Special Instructions</h3>
                </div>
                <div className="space-y-4">
                  <p className="text-gray-500 font-medium text-sm">Add a note to your order (optional)</p>
                  <textarea 
                    value={specialInstructions}
                    onChange={(e) => setSpecialInstructions(e.target.value)}
                    placeholder="Any special requests, notes..."
                    className="w-full h-20 bg-[#F3F5F7] rounded-xl p-4 text-sm outline-none resize-none focus:ring-1 ring-blue-200"
                  />
                </div>
            </div>
          </div>

          {/* RIGHT SECTION: SUMMARY */}
          <div className="lg:col-span-5 space-y-6">
            <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-sm md:text-base font-bold flex items-center gap-2"><Tag size={18} /> Promo Code</h3>
                {applicableCoupons.length > 0 && <button onClick={() => setShowCouponModal(true)} className="text-xs font-bold text-blue-600 flex items-center gap-1.5 hover:underline"><Ticket size={14}/> View all({applicableCoupons.length})</button>}
              </div>
              <div className="flex gap-2 mb-3">
                <input type="text" value={promoCode} onChange={(e) => setPromoCode(e.target.value.toUpperCase())} placeholder="Enter code" className="flex-1 bg-blue-50/50 rounded-lg px-4 py-3 text-sm outline-none focus:ring-1 ring-blue-300" />
                <button onClick={() => handleApplyPromo()} className="px-5 py-2 border border-[#B5CAFF] text-blue-500 rounded-lg text-sm font-bold hover:bg-blue-50 transition-colors">Apply</button>
              </div>
              
            </div>

            <div className="bg-white rounded-xl border border-[#B5CAFF] p-4 md:p-6 shadow-sm">
              <h3 className="text-base md:text-lg font-bold mb-6">Order Summary</h3>
              <div className="space-y-4 text-sm md:text-base font-medium text-gray-500">
                <div className="flex justify-between">
                  <span>Subtotal ({items.reduce((a, b) => a + b.quantity, 0)} items)</span>
                  <span className="text-black font-bold">₹{summary.subtotal.toFixed(2)}</span>
                </div>
                <div className="flex justify-between text-green-600">
                  <span>Discount</span>
                  <span>-₹{summary.discount.toFixed(2)}</span>
                </div>
                {couponDiscount > 0 && (
                   <div className="flex justify-between text-blue-600">
                    <span>Coupon Discount</span>
                    <span>-₹{couponDiscount.toFixed(2)}</span>
                  </div>
                )}
                {summary.payable > 0 && (
                  <div className="flex justify-between items-center">
                    <span>Delivery</span>

                    {isFreeDelivery ? (
                      <span className="text-green-600 font-medium">
                        Free
                      </span>
                    ) : (
                      <span className="text-orange-600 font-medium">
                        Charges applicable
                      </span>
                    )}
                  </div>
                )}
                <div className="pt-6 border-t flex justify-between items-center text-black">
                  <span className="text-lg font-bold">Total</span>
                  <span className="text-2xl font-black">₹{totalAmount.toFixed(2)}</span>
                </div>
              </div>
              <button 
                onClick={handlePlaceOrder} 
                disabled={loading || items.length === 0} 
                className="w-full bg-[#007BFF] hover:bg-blue-700 text-white py-4 rounded-xl mt-8 font-bold shadow-lg active:scale-[0.98] transition-all disabled:bg-gray-400 tracking-wider"
              >
                {loading ? "PROCESSING..." : "PLACE ORDER"}
              </button>
              {/* SAVINGS INFO */}
              {summary.discount > 0 && (
                <p className="mt-4 py-3 rounded-lg text-sm bg-green-100 text-[#008622] text-center">
                  You will save ₹{(summary.discount + couponDiscount).toFixed(2)} on this order
                </p>
              )}
            </div>

            <div className="bg-white rounded-xl border border-[#B5CAFF] p-6 space-y-6 text-gray-500">
               <div className="flex items-center gap-4"><Truck className="text-blue-500" size={20}/><div><p className="text-sm font-bold text-black">Safe Delivery</p><p className="text-xs">Tracking available after dispatch</p></div></div>
               <div className="flex items-center gap-4 border-t pt-5 border-gray-50"><ShieldCheck className="text-green-500" size={20}/><div><p className="text-sm font-bold text-black">Buyer Protection</p><p className="text-xs">Secure payment & easy returns</p></div></div>
            </div>
          </div>
        </div>
      </div>

      {/* MODALS */}
      {showSelectionModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[2000] flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-lg rounded-3xl overflow-hidden shadow-2xl animate-in zoom-in duration-200">
             <div className="p-6 bg-blue-600 text-white flex justify-between items-center"><h2 className="font-bold text-lg">Select Address</h2><button onClick={() => setShowSelectionModal(false)}><X size={24}/></button></div>
             <div className="p-6 max-h-[60vh] overflow-y-auto space-y-4 bg-gray-50">
                {addresses.map((addr) => (
                  <div key={addr._id} className="relative bg-white p-5 rounded-2xl border-2 border-transparent hover:border-blue-500 cursor-pointer shadow-sm transition-all group">
                    <div onClick={() => { if(targetType === "shipping") setShippingAddress(addr); else setBillingAddress(addr); setShowSelectionModal(false); }}>
                      <p className="font-bold text-gray-900">{addr.name}</p>
                      <p className="text-sm text-gray-500 mt-1">{addr.flat}, {addr.area}</p>
                    </div>
                    <button onClick={(e) => { e.stopPropagation(); setEditingAddress(addr); setShowSelectionModal(false); setShowFormModal(true); }} className="absolute top-4 right-4 p-2 text-gray-300 hover:text-blue-500 bg-gray-50 rounded-lg"><Edit2 size={16} /></button>
                  </div>
                ))}
                <button onClick={() => { setShowSelectionModal(false); setEditingAddress(null); setShowFormModal(true); }} className="w-full py-4 rounded-2xl border-2 border-dashed border-blue-200 text-blue-500 font-bold hover:bg-blue-50">+ Add New Address</button>
             </div>
          </div>
        </div>
      )}

      {showCouponModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[2000] flex items-center justify-center p-4">
          <div className="bg-white w-full max-w-md rounded-3xl overflow-hidden shadow-2xl animate-in zoom-in duration-200">
             <div className="p-5 border-b flex justify-between items-center"><h2 className="font-bold text-lg">Available Coupons</h2><button onClick={() => setShowCouponModal(false)} className="p-1 rounded-full hover:bg-gray-100"><X size={24}/></button></div>
             <div className="p-5 max-h-[60vh] overflow-y-auto space-y-4">
               {applicableCoupons.length > 0 ? applicableCoupons.map((c) => (
                 <div key={c._id} className="border-2 border-dashed border-blue-200 rounded-2xl p-4 flex justify-between items-center bg-blue-50/30">
                   <div>
                     <p className="text-blue-600 font-black text-lg tracking-tight">{c.code}</p>
                     <p className="text-xs font-bold text-gray-600 mt-0.5">{c.discountType === 'percentage' ? `${c.discountValue}% OFF` : `₹${c.discountValue} OFF`}</p>
                   </div>
                   <button onClick={() => handleApplyPromo(c.code)} className="bg-blue-600 text-white text-xs font-bold px-4 py-2 rounded-lg hover:bg-blue-700">APPLY</button>
                 </div>
               )) : <div className="text-center py-10"><Tag size={40} className="mx-auto text-gray-200 mb-3"/><p className="text-sm font-medium text-gray-400">No coupons available for these items.</p></div>}
             </div>
          </div>
        </div>
      )}

      {/* NEW AUTH MODAL INTEGRATION */}
      <AuthModal 
        isOpen={showAuthModal} 
        onClose={() => setShowAuthModal(false)} 
        onSuccess={() => {
            setShowAuthModal(false);
            fetchAddresses(); // Refresh addresses after login
        }} 
      />

      <AddressFormModal isOpen={showFormModal} onClose={() => { setShowFormModal(false); setEditingAddress(null); }} onSuccess={fetchAddresses} initialData={editingAddress} />
    </div>
  );
};

export default CheckOutPage;